<template>
  <b-container>
    <b-row align="center" align-h="center" align-v="center" align-items-center="true">
      <b-col sm="3">
        <b-row>
          <b-col>
            <b-form @submit.prevent="login">
              <b-row>
                <b-col>
                  <b-form-input v-model="username" placeholder="Username" v-focus></b-form-input>
                </b-col>
              </b-row>

              <b-row>
                <b-col class="mt-1">
                  <b-form-input v-model="password" placeholder="Password" type="password"></b-form-input>
                </b-col>
              </b-row>

              <b-row class="mt-3">
                <b-col  v-if="error" align="left">
                  <p class="login-error">
                    Invalid Credentials
                  </p>
                </b-col>
                <b-col align="right">
                  <b-button type="submit" variant="primary">Login</b-button>
                </b-col>
              </b-row>

            </b-form>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import auth from './auth.js';

export default {
  data () {
    return {
      username: '',
      password: '',
      error: false
    }
  },
  methods: {
    login () {
      auth.login(this.username, this.password, loggedIn => {
        if (!loggedIn) {
          this.error = true
        } else {
          this.$router.replace(this.$route.query.redirect || '/')
        }
      })
    }
  }
}
</script>

<style>
.login-error {
  color: red;
  background-color: white;
}
</style>



// WEBPACK FOOTER //
// src/Login.vue